export interface SystemIdRowEntry {
  id: string;
  label: string;
  value?: string | number | null;
  mono?: boolean;
  copyable?: boolean;
}

export type FilledSystemIdRowEntry = SystemIdRowEntry & { value: string };

export function getFilledSystemIdRows(rows: ReadonlyArray<SystemIdRowEntry>): FilledSystemIdRowEntry[] {
  return rows.flatMap((row) =>
    row.value === null || row.value === undefined || row.value === "" ? [] : [{ ...row, value: String(row.value) }],
  );
}
